export enum FORM_TEMPLATE {
	FORM_TEMPLATE_LOAD_START = 'FORM_TEMPLATE_LOAD_START',
	FORM_TEMPLATE_LOAD_DONE = 'FORM_TEMPLATE_LOAD_DONE',
	FORM_TEMPLATE_LOAD_FAIL = 'FORM_TEMPLATE_LOAD_FAIL',
	FORM_TEMPLATE_CHANGE_BACKUP_STATUS = 'FORM_TEMPLATE_CHANGE_BACKUP_STATUS'
}

export enum FORM_TEMPLATE_QUEUES {
	FORM_TEMPLATE_QUEUES_LOAD_START = 'FORM_TEMPLATE_QUEUES_LOAD_START',
	FORM_TEMPLATE_QUEUES_LOAD_DONE = 'FORM_TEMPLATE_QUEUES_LOAD_DONE',
	FORM_TEMPLATE_QUEUES_LOAD_FAIL = 'FORM_TEMPLATE_QUEUES_LOAD_FAIL'
}

export enum FORM_TEMPLATE_DATABASES {
	FORM_TEMPLATE_DATABASES_LOAD_START = 'FORM_TEMPLATE_DATABASES_LOAD_START',
	FORM_TEMPLATE_DATABASES_LOAD_DONE = 'FORM_TEMPLATE_DATABASES_LOAD_DONE',
	FORM_TEMPLATE_DATABASES_LOAD_FAIL = 'FORM_TEMPLATE_DATABASES_LOAD_FAIL'
}

export enum FORM_TEMPLATE_PROCEDURES {
	FORM_TEMPLATE_PROCEDURES_LOAD_START = 'FORM_TEMPLATE_PROCEDURES_LOAD_START',
	FORM_TEMPLATE_PROCEDURES_LOAD_DONE = 'FORM_TEMPLATE_PROCEDURES_LOAD_DONE',
	FORM_TEMPLATE_PROCEDURES_LOAD_FAIL = 'FORM_TEMPLATE_PROCEDURES_LOAD_FAIL'
}

export enum FORM_TEMPLATE_COLUMNS {
	FORM_TEMPLATE_COLUMNS_LOAD_START = 'FORM_TEMPLATE_COLUMNS_LOAD_START',
	FORM_TEMPLATE_COLUMNS_LOAD_FAIL = 'FORM_TEMPLATE_COLUMNS_LOAD_FAIL',
	FORM_TEMPLATE_COLUMNS_LOAD_DONE = 'FORM_TEMPLATE_COLUMNS_LOAD_DONE'
}

export enum FORM_TEMPLATE_TABS {
	FORM_TEMPLATE_TABS_LOAD_START = 'FORM_TEMPLATE_TABS_LOAD_START',
	FORM_TEMPLATE_TABS_LOAD_FAIL = 'FORM_TEMPLATE_TABS_LOAD_FAIL',
	FORM_TEMPLATE_TABS_LOAD_DONE = 'FORM_TEMPLATE_TABS_LOAD_DONE'
}

export enum FORM_TEMPLATE_ELEMENTS {
	FORM_TEMPLATE_ELEMENTS_LOAD_START = 'FORM_TEMPLATE_ELEMENTS_LOAD_START',
	FORM_TEMPLATE_ELEMENTS_LOAD_FAIL = 'FORM_TEMPLATE_ELEMENTS_LOAD_FAIL',
	FORM_TEMPLATE_ELEMENTS_LOAD_DONE = 'FORM_TEMPLATE_ELEMENTS_LOAD_DONE'
}

export enum FORM_TEMPLATE_CONFIGS {
	FORM_TEMPLATE_CONFIGS_LOAD_START = 'FORM_TEMPLATE_CONFIGS_LOAD_START',
	FORM_TEMPLATE_CONFIGS_LOAD_FAIL = 'FORM_TEMPLATE_CONFIGS_LOAD_FAIL',
	FORM_TEMPLATE_CONFIGS_LOAD_DONE = 'FORM_TEMPLATE_CONFIGS_LOAD_DONE'
}

export enum FORM_TABLE_ITEMS {
	FORM_TABLE_ITEMS_LOAD_START = 'FORM_TABLE_ITEMS_LOAD_START',
	FORM_TABLE_ITEMS_LOAD_FAIL = 'FORM_TABLE_ITEMS_LOAD_FAIL',
	FORM_TABLE_ITEMS_LOAD_DONE = 'FORM_TABLE_ITEMS_LOAD_DONE'
}

export enum FORM_PLACEHOLDER {
	FORM_PLACEHOLDER_HEIGHT = 'FORM_PLACEHOLDER_HEIGHT',
	FORM_PLACEHOLDER_WIDTH = 'FORM_PLACEHOLDER_WIDTH'
}

export const FORM_TEMPLATE_ITEM_COPY = 'FORM_TEMPLATE_COPY'
export const FORM_EDIT_CHANGE = 'FORM_EDIT_CHANGE'
export const FORM_EDITED = 'FORM_EDITED'
export const RESET_FORM_STORE = 'RESET_FORM_STORE'
export const LOAD = 'LOAD'
